import BaseService from "src/packages/BaseService";

export default class GameDataService extends BaseService {
	static get className () {
		return "data/game";
	}

	static async setScore (id, data) {
		const response = await BaseService.getService().post("score/event/" + id, data);
		return response.data;
	}

}
